import { render } from "./NoEventsContent.vue?vue&type=template&id=85283a3a&scoped=true"
import script from "./NoEventsContent.vue?vue&type=script&lang=js"
export * from "./NoEventsContent.vue?vue&type=script&lang=js"

import "./NoEventsContent.vue?vue&type=style&index=0&id=85283a3a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85283a3a"]])

export default __exports__